/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, {forwardRef} from "react";
import PropTypes from "prop-types";
import { Button, Typography, Skeleton } from "@getgo/chameleon-web-react-wrapper";
import classes from "./boxed-container-view.scss";
import { Box } from "@mui/material";

export const BoxedContainer = forwardRef((
  {
    title,
    children,
    buttonText,
    onClick,
    buttonIcon,
    showCTAButton = true,
    disabled = false,
    isLoading = false,
  },
  ref
) => {
  return (
    <React.Fragment>
      <Box className={classes['mainBoxedContainer']} ref={ref}>
        <Box className={classes['header']}>
          {title && (
            <Typography tag="h2" variant="heading-small">
              {title}
            </Typography>
          )}
          {!!showCTAButton && (
            <Button
              data-testid="box-button"
              role="button"
              onClick={onClick}
              leadingIcon={buttonIcon}
              variant="secondary"
              disabled={disabled}
            >
              {buttonText}
            </Button>
          )}
        </Box>
        {isLoading && <Skeleton variant="rectangle" size="xxxlarge" />}
        {!isLoading && children}
      </Box>
    </React.Fragment>
  );
});
BoxedContainer.propTypes = {
  buttonText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  title: PropTypes.object.isRequired,
  buttonIcon: PropTypes.element.isRequired,
  onClick: PropTypes.func.isRequired,
  showCTAButton: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default BoxedContainer;
